/**
 * The id AI autofill knows a card's file by, one id for the file's whole life. A file added before the profile is saved has no
 * document id yet, so it gets `pending:<n>`; when it is saved, the document keeps that id. What was read from it stays read, and
 * removing the saved document takes back what the file filled. A document that was never pending on this page is `stored:<documentId>`.
 */
const pendingIds = new WeakMap<File, string>()
const savedPendingIds = new Map<string, string>()
let nextPendingId = 0

/** A pending file's id: the same for the same File while it waits on the card, also after the card remounts (a tab switched). */
export const pendingSourceId = (file: File): string => {
    let id = pendingIds.get(file)
    if (!id) {
        id = `pending:${++nextPendingId}`
        pendingIds.set(file, id)
    }
    return id
}

/** A saved document's id: the pending file's id when it was saved from one, `stored:<documentId>` otherwise. */
export const storedSourceId = (documentId: string): string => savedPendingIds.get(documentId) ?? `stored:${documentId}`

/** A pending file was saved as this document: the document keeps the file's id. A file the card never gave an id to has none to keep. */
export const keepSourceIdOnSave = (file: File, documentId: string): void => {
    const id = pendingIds.get(file)
    if (id) savedPendingIds.set(documentId, id)
}
